/* Mikaya — blog motion. Reveal-on-scroll for article elements + subtle hero
   parallax. Standardised for every post. Namespaced, idempotent, a11y-safe. */
(function () {
  function init() {
    var root = document.querySelector('.mk-longform');
    if (!root || root.dataset.mkBlogReady) return;
    root.dataset.mkBlogReady = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* elements that should reveal as they enter */
    var sel = ':scope > h2, :scope > h3, :scope > figure, :scope > .mk-table-wrap, '
      + ':scope > .mk-callout, :scope > .mkw, :scope > .mk-embed, :scope > .mk-keytakeaway, '
      + ':scope > .mk-answer, :scope > .mk-faq, :scope > blockquote';
    var targets = [];
    try { targets = Array.prototype.slice.call(root.querySelectorAll(sel)); } catch (e) { targets = []; }
    var krCards = document.querySelectorAll('.mk-kr-card, .mk-keepreading__head, .mk-kr-foot > *');
    krCards.forEach(function (el) { targets.push(el); });

    if (reduce || !('IntersectionObserver' in window) || !targets.length) {
      return; /* CSS leaves them fully visible */
    }
    targets.forEach(function (el) { el.classList.add('mk-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (el) { io.observe(el); });

    /* subtle parallax on the hero figure image */
    if (!reduce) {
      var hero = root.querySelector('.mk-figure--hero img');
      if (hero) {
        var ticking = false;
        window.addEventListener('scroll', function () {
          if (ticking) return; ticking = true;
          window.requestAnimationFrame(function () {
            var r = hero.getBoundingClientRect(), vh = window.innerHeight;
            if (r.bottom > 0 && r.top < vh) {
              var shift = ((vh - r.top) / (vh + r.height) - 0.5) * -16;
              hero.style.transform = 'translateY(' + shift.toFixed(1) + 'px) scale(1.05)';
            }
            ticking = false;
          });
        }, { passive: true });
      }
    }
  }
  /* Table of contents — built from the article's H2s */
  function buildTOC() {
    var toc = document.querySelector('[data-mk-toc]');
    var article = document.querySelector('.mk-longform');
    if (!toc || !article || toc.dataset.mkTocReady) return;
    toc.dataset.mkTocReady = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nav = toc.querySelector('.mk-toc__nav');
    var hs = article.querySelectorAll(':scope > h2');
    if (hs.length < 2) hs = article.querySelectorAll('h2');
    if (hs.length < 2) { toc.style.display = 'none'; return; }
    var links = [];
    Array.prototype.forEach.call(hs, function (h, i) {
      if (!h.id) {
        var slug = h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        h.id = slug || ('sec-' + i);
      }
      var a = document.createElement('a');
      a.className = 'mk-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/^[^\w(]+/, '').trim();
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
      });
      nav.appendChild(a);
      links.push({ a: a, h: h });
    });
    if (window.matchMedia('(min-width: 990px)').matches) toc.open = true;
    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) links.forEach(function (l) { l.a.classList.toggle('is-active', l.h === e.target); });
        });
      }, { rootMargin: '-12% 0px -78% 0px' });
      Array.prototype.forEach.call(hs, function (h) { spy.observe(h); });
    }
  }
  function boot() { init(); buildTOC(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
